import { Item, ItemKit } from '@he-novation/config/types/item.types';
import { atom } from 'jotai';

export const itemsAtom = atom<Item[] | null>(null);

export const itemKitsAtom = atom<ItemKit[] | null>(null);
